import React from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import { Dashboard } from "@uppy/react";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/url/dist/style.css";

const wrapperStyles = {
  ".uppy-Dashboard-inner": {
    backgroundColor: "initial",
    border: "none",
  },
  ".uppy-ProviderBrowser-headerBar:empty": {
    display: "none",
  },
};

const PostFilePicker = ({ ...props }) => {
  const { colorMode } = useColorMode();

  return (
    <Box sx={wrapperStyles}>
      <Dashboard
        showSelectedFiles={false}
        disableStatusBar
        proudlyDisplayPoweredByUppy={false}
        theme={colorMode}
        {...props}
      />
    </Box>
  );
};

PostFilePicker.propTypes = {};

PostFilePicker.defaultProps = {};

export default PostFilePicker;
